import Text5_2 from './Text5_2'
export default Text5_2
